// Adapted from @react-admin/ra-form-layout@1.9.0 — see ../README.md
import { Step, StepButton, StepLabel, Stepper, StepperProps } from '@mui/material'
import * as React from 'react'
import type { WizardFormStepProps } from './WizardFormStep'

/**
 * Progress component rendering a stepper on top of the wizard.
 *
 * This is only the DEFAULT for <WizardForm progress>. GuidedBoatForm supplies
 * its own vertical stepper, so this renders nowhere in the app today — it is
 * kept so <WizardForm> stays usable on its own.
 */
export const WizardProgress = ({
  currentStep = 0,
  onStepClick,
  steps = [],
  ...rest
}: WizardFormProgressProps) => {
  const handleStepClick = (index: number) => (): void => onStepClick?.(index)

  return (
    <Stepper activeStep={currentStep} {...rest}>
      {steps.map((step, index) => {
        const label = React.cloneElement(step, { intent: 'label' })

        return (
          <Step key={`step_${index}`}>
            {!onStepClick ? (
              <StepLabel>{label}</StepLabel>
            ) : (
              <StepButton onClick={handleStepClick(index)}>{label}</StepButton>
            )}
          </Step>
        )
      })}
    </Stepper>
  )
}

export type WizardFormProgressProps = Omit<StepperProps, 'activeStep' | 'children'> & {
  currentStep?: number
  onStepClick?: (index: number) => void
  steps?: React.ReactElement<WizardFormStepProps>[]
}

export default WizardProgress
